export default {
  lang: 'English',
  zhyun: '',
  navName1: 'Home',
  navName2: 'About',
  navName3: 'News',
  navName4: 'Products',
  navName5: 'Case',
  navName6: 'Contact',
  navName7: 'Technical',
  servicePhone: '',
  serviceName: 'Paperless System Developer',
  footerContactTitle: 'Contact Us',
  footerPhoneLabel: 'Phone: ',
  footerEmailLabel: 'Email: ',
  footerAddressLabel: 'Address: ',
  footerAddressValue: 'No. 902, Building E, Jindi Chuangzhi Hui, No. 19 Nanxiang Third Road, Huangpu District, Guangzhou, Guangdong Province',
  footerFollowTitle: 'Follow Us',
  footerWebsiteLabel: 'Website: ',
  footerWechatLabel: 'WeChat Service: ',
  footerWechatValue: '智会云GZZHYUN',
  footerWechatTitle: 'WeChat Service',
  footerCopyright: 'Copyright © 2018-2026 Guangzhou Zhihui Cloud Technology Co., Ltd. All rights reserved.',
  websiteTitle: 'Guangzhou Zhihui Cloud Technology Co., Ltd.',
  home: {
    customerFirst: 'Customer First',
    professional: 'Professional',
    achievement: 'Achievement',
    contactUs: 'Contact Us',
    companyInformation: 'COMPANY INFORMATION',
    companyProfile: 'Company Profile',
    aboutZhyun: "About 'Zhihui Cloud'",
    companyDescription: 'Guangzhou Zhihui Cloud Technology Co., Ltd. is a high-tech enterprise recognized by the state. It is a vibrant and creative company with a professional and innovative top R&D team. It is a high-tech company specializing in the independent research and development and production of various conference systems. The company focuses on the research, development, production, and sales of paperless conference systems, electronic nameplate systems, digital conferences, central control matrices, etc. With customer customization as its feature, it creates a fast, efficient, and personalized overall conference environment for customers.',
    companyNews: 'Company News',
    projectCases: 'Project Cases',
    productCenter: 'PRODUCT CENTER',
    enterpriseHonor: 'ENTERPRISE HONOR'
  },
  aboutUs: {
    companyIntroduction: 'COMPANY INTRODUCTION',
    industry: 'INDUSTRY',
    certification: 'CERTIFICATION'
  },
  news: {
    newsInformation: 'COMPANY INFORMATION'
  },
  products: {
    productCenter: 'PRODUCT CENTER',
    viewMore: 'View More',
    videoShowcase: 'Video Showcase',
    videos: 'Videos',
    noData: 'No Data'
  },
  case: {
    case: 'CASE'
  },
  technical: {
    technical: 'TECHNICAL DOCUMENTS',
    download: 'Download'
  },
  contactUs: {
    contactUs: 'CONTACT US',
    contactInformation: 'Contact Information',
    businessPhone: 'Business Phone: ',
    contactPerson: 'Contact Person: ',
    contactPhone: 'Phone: ',
    wechat: 'WeChat: ',
    contactAddress: 'Address',
    leaveMessage: 'Leave a Message',
    leaveMessageDesc: 'Tell us about your needs or questions and we will contact you soon.',
    messageCompany: 'Company',
    messageCompanyPlaceholder: 'Please enter your company name',
    messageName: 'Name',
    messageNamePlaceholder: 'Please enter your name',
    messagePhone: 'Phone',
    messagePhonePlaceholder: 'Please enter your phone number',
    messageWechat: 'WeChat',
    messageWechatPlaceholder: 'Please enter your WeChat ID (optional)',
    messageWhatsappPlaceholder: 'Please enter your WhatsApp number (optional)',
    messageEmail: 'Email',
    messageEmailPlaceholder: 'Please enter your email (optional)',
    messageContent: 'Message',
    messageContentPlaceholder: 'Please enter your requirements, questions, or cooperation intent',
    messageSubmit: 'Submit',
    messagePhoneInvalid: 'Please enter a valid phone number',
    messageEmailInvalid: 'Please enter a valid email address',
    messageContentRequired: 'Please enter your message',
    messageSubmitSuccess: 'Message submitted successfully. We will contact you soon.',
    address: 'Address: No. 902, Building E, Jindi Chuangzhi Hui, No. 19 Nanxiang Third Road, Huangpu District, Guangzhou, Guangdong Province, China',
    factoryAddress: 'Factory Address: No. 902, Building E, Jindi Chuangzhi Hui, No. 19 Nanxiang Third Road, Huangpu District, Guangzhou, Guangdong Province, China',
    zhyunName: 'Guangzhou Zhihui Cloud Technology Co., Ltd.',
    zhyunAddress: 'Building E, No. 902',

    onlineMessage: 'Online Message',
    formCompany: 'Company (required)',
    formName: 'Name (required)',
    formPhone: 'Phone (required)',
    formEmail: 'Email (optional)',
    formWechat: 'WeChat (optional)',
    formWhatsapp: 'WhatsApp (optional)',
    formContent: 'Please enter your question...',
    formClose: 'Close',
    formSend: 'Send',
    firstReplyContent: 'Hello! We are glad to serve you. To enable our sales team to contact you promptly and provide detailed information, could you please provide your WhatsApp number or phone number?'
  }
}
